import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollReset = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const resetScroll = () => {
      // Primeiro scroll suave
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      // Força um segundo scroll após o DOM atualizar
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      });
    };

    // Reseta o scroll em cada navegação
    resetScroll();

    // Adiciona um listener para o evento de carregamento
    window.addEventListener('load', resetScroll);

    return () => {
      window.removeEventListener('load', resetScroll);
    };
  }, [pathname]);
}; 